import React from "react";
import moment from "moment";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import { orderService } from "../../../Core/Api/services";
import OrderTable, { OrderTableContext } from "../../../Components/Table/OrdersTable/orders-table";
import TableSkeleton from "../../../Components/Table/TableSkeleton";

function OrderCustomerOrders() {
    const [isLoading, setLoading] = React.useState(true);
    const [rows, setData] = React.useState<DbOrderItemInfos[]>([]);

    // Fetching data
    React.useEffect(() => {
        const start = moment().add(-15, "d").format("YYYY-MM-DD");
        const end = moment().add(1, "d").format("YYYY-MM-DD");

        // Todo: make a call more restrictive
        orderService.GetItemsListByDate(start, end).then(function (response) {
            setData(response.items.filter((x) => x.customerId !== null));
            setLoading(false);
        });
    }, []);

    return <OrderTable isLoading={isLoading} context={OrderTableContext.Customers} orders={rows} />;
}

export default OrderCustomerOrders;
